import React, { forwardRef } from "react";
import { Button } from '@material-tailwind/react';
import "./Star.css";

const Star = ({ setShowModal }) => {
  return (
    <div id="moreThanJustMusic">
      <div className="star-section w-full flex flex-col md:px-20 space-y-4 md:flex-row md:space-x-0 md:space-y-0 items-center">
        <div className="md:w-2/3 lg:w-2/4 w-full star-container">
          <div className="font-normal text-white relative pe-4 md:pe-10 ">
            <h1 className="text-2xl md:text-4xl mb-4 font-black">
              What’s More Than Just Music?
            </h1>
            <p className="text-lg mb-8">
              Welcome to More Than Just Music – a unique fusion of talent and spirit, where the soul-stirring power of music harmonises with a profound purpose. Taylor's Duckie and Taylor's Music Club have united in a momentous collaboration, sharing a common vision to make a meaningful impact in our community. 
            </p>
            <p className="text-lg mb-8">
              At Taylor's Duckie, our identity is defined by a relentless passion for creating positive change. Our CSR initiatives are the heartbeat of our commitment, raising awareness and support for social causes that strike a chord with our core values. And now, as the stage is set for this remarkable event, we begin a new chapter with Taylor's Music Club to champion a significant cause – empowering underprivileged children through our support for the Dignity for Children Foundation. 
            </p>
            <p className="text-lg mb-8">
              Register using the button below to redeem exclusive duckie merchandise!
            </p>
          </div>

          <div className="w-full">
            {/* eslint-disable-next-line */}
            <a 
              href="#"
              onClick={(e) => {
                e.preventDefault();
                setShowModal(true)
              }}
              className="text-cyan-500"
            >
              <Button variant="outlined" style={{ color: '#D1597A' }} className="hidden md:inline-block bg-white px-16 text-2xl md:text-4xl font-black">
                Register Here
              </Button>
              <Button variant="filled" className="md:hidden bg-white text-black px-16 border-2 md:border-4 text-2xl md:text-4xl font-black">
                Register Here
              </Button>
            </a>
          </div>
        </div>
        <div className="md:w-3/3 lg:w-2/4 w-full camp-picture hidden md:flex">
          <img
            src={require("../../Assets/taylors-under-the-stars-about-us-960x1080.png")}
            className="object-cover rounded-3xl"
            alt="camp"
          />
        </div>
      </div>
    </div>
  );
};

export default forwardRef(Star);
